function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { addTrackingToFormSubmit } from "../../gtm-tracking";
(function ($) {
  window.DGS.OnLoad.getInstance().register(function () {
    if ($('#wrapper').length) {
      var focusHandler = function focusHandler() {
        $inputs.focusout(function () {
          submitFormFunction.preValidation(this);
        });
        $('.scfCheckbox input').focusout(function () {
          this.checked ? this.parentElement.classList.remove('unchecked') : this.parentElement.classList.add('unchecked');
        });
      };
      var checkInputFieldValidation = function checkInputFieldValidation() {
        for (var i = 0; i < $inputFields.length; i++) {
          if ($('.scfValidatorRequired').length > 0 && $inputFields[i].value === '') {
            $inputFields[i].classList.add('inputError');
            $inputFields[i].blur();
          }
        }
      };
      var validateCaptcha = function validateCaptcha() {
        var $captchaValidator = document.querySelector('.scfCaptcha .scfValidator');
        if ($captchaValidator) {
          document.querySelector('.scfCaptcha').scrollIntoView();
          window.scrollBy(0, -60);
        }
      };
      // There are no sitecore sales rep contact form components on page. Break out
      $('.scfCheckbox input').addClass('checkBox');
      var $inputs = $('.scfSingleLineTextBorder .scfSingleLineGeneralPanel input, .scfEmailBorder .scfEmailGeneralPanel input, .scfTelephoneBorder .scfTelephoneGeneralPanel input, .scfNumberBorder .scfNumberGeneralPanel input, .scfMultipleLineGeneralPanel textarea');
      focusHandler();
      var $inputFields = $('.scfSectionContent .scfSingleLineGeneralPanel input');
      $inputFields.push(document.querySelector('.scfTelephoneTextBox'), document.querySelector('.scfEmailTextBox'));
      checkInputFieldValidation();
      validateCaptcha();
      var submitFormFunction = {
        isValid: false,
        validationDataName: 'data-val-validationexpression',
        init: function init() {
          var _this = this;
          submitFormFunction.fakeInputs();
          document.querySelectorAll('.scfForm input[type="submit"].fake-button').forEach(function (element) {
            element.addEventListener('click', _this.clickHandler, false);
          });
          document.querySelectorAll('.scfForm input[type="text"]:not(.scfCaptchaTextBox), .scfForm textarea').forEach(function (element) {
            element.addEventListener('keyup', _this.pressHandler, false);
          });
          document.querySelectorAll('input[type="file"]').forEach(function (element) {
            element.addEventListener('change', function () {
              if (element.value) {
                element.classList.remove('inputError');
              } else {
                element.classList.add('inputError');
              }
            });
          });
          document.querySelectorAll('input[type="checkbox"]').forEach(function (element) {
            element.addEventListener('change', function () {
              if (element.checked) {
                element.parentElement.classList.remove('unchecked');
              } else {
                element.parentElement.classList.add('unchecked');
              }
            });
          });
        },
        pressHandler: function pressHandler(event) {
          submitFormFunction.preValidation(event.target);
        },
        regexpValidation: function regexpValidation($input, elements, inputValue) {
          var regExp, regExp2, currentIndex;
          var containerClasses = $($input).closest('.scfSectionContent > div')[0].classList;
          var regexFromClass = _toConsumableArray(containerClasses).filter(function (c) {
            return c.includes('regex');
          });
          if (elements[0]) {
            regExp = new RegExp(String(elements[0].getAttribute(this.validationDataName)));
            if (regexFromClass.length > 0) {
              var decodedRegex = decodeURIComponent(regexFromClass[0].substring('regex.'.length));
              regExp = new RegExp(String(decodedRegex));
            }
            regExp = regExp.test(inputValue);
            currentIndex = 0;
          }
          if (elements[1]) {
            regExp2 = new RegExp(String(elements[1].getAttribute(this.validationDataName)));
            regExp2 = regExp2.test(inputValue);
            currentIndex = regExp && !regExp2 ? 1 : 0;
          }
          var regExpValid = (regExp || regExp2) && inputValue.length > 0;
          if (regExpValid) {
            elements.each(function (index, element) {
              return element && element.style ? element.style.display = 'none' : null;
            });
            $input.classList.remove('inputError');
          } else {
            elements[currentIndex].style.display = 'block';
            $input.classList.add('inputError');
          }
          return !regExpValid;
        },
        preValidation: function preValidation($input) {
          var inputValue = $input.value;
          var validationData = $($input).parent().find("[".concat(this.validationDataName, "]"));
          return this.regexpValidation($input, validationData, inputValue);
        },
        checkIsRequired: function checkIsRequired(element) {
          return element.contains(element.querySelector('.scfRequired')) || element.contains(element.querySelector('.scfValidatorRequired'));
        },
        validate: function validate(event) {
          var _this2 = this;
          var validated;
          this.isValid = false;
          $(event.target).closest('.scfForm').find('.scfSectionContent > div').each(function (index, element) {
            var $input = element.querySelector('input[type="text"]:not(.scfCaptchaTextBox)');
            var $checkbox = element.querySelector('input[type="checkbox"]');
            var $textarea = element.querySelector('textarea');
            var $uploadFile = element.querySelector('input[type="file"]');
            if ($input) {
              var isRequired = _this2.checkIsRequired(element);
              if (isRequired) {
                validated = _this2.preValidation($input);
                _this2.isValid = _this2.isValid ? true : validated;
              }
            }
            if ($textarea) {
              var _isRequired = _this2.checkIsRequired(element);
              if (_isRequired) {
                validated = _this2.preValidation($textarea);
                _this2.isValid = _this2.isValid ? true : validated;
              }
            }
            if ($checkbox) {
              var _isRequired2 = _this2.checkIsRequired(element);
              if (_isRequired2) {
                $checkbox.checked ? $checkbox.parentElement.classList.remove('unchecked') : $checkbox.parentElement.classList.add('unchecked');
                _this2.isValid = _this2.isValid ? true : !$checkbox.checked;
              }
            }
            if ($uploadFile) {
              var _isRequired3 = _this2.checkIsRequired(element);
              if (_isRequired3) {
                if ($uploadFile.value.length > 0) {
                  $uploadFile.classList.remove('inputError');
                } else {
                  $uploadFile.classList.add('inputError');
                }
                _this2.isValid = _this2.isValid ? true : !($uploadFile.value.length > 0);
              }
            }
          });
        },
        fakeInputs: function fakeInputs() {
          document.querySelectorAll('.scfForm input[type="submit"]').forEach(function (element) {
            var newElement = element.cloneNode(true);
            newElement.setAttribute('onclick', null);
            newElement.classList.add('fake-button');
            element.parentElement.appendChild(newElement);
            element.style.display = 'none';
          });
        },
        clickHandler: function clickHandler(e) {
          e.preventDefault();
          submitFormFunction.validate(e);
          if (!submitFormFunction.isValid) {
            var parent = e.target.parentNode;
            addTrackingToFormSubmit();
            parent.querySelector('.scfForm input[type="submit"]:not(.fake-button)').click();
          } else {
            document.querySelector('.inputError, .unchecked').scrollIntoView();
            window.scrollBy(0, -60);
          }
        }
      };
      submitFormFunction.init();
    }
  });
})(jQuery);